module.exports = __webpack_public_path__ + "img/contact-bg.c59bfa53.png";